import { render, staticRenderFns } from "./PublisherPaymentForm.vue?vue&type=template&id=60e42ad5&scoped=true"
import script from "./PublisherPaymentForm.vue?vue&type=script&lang=js"
export * from "./PublisherPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e42ad5",
  null
  
)

export default component.exports